module.exports = __webpack_public_path__ + "static/media/Cabo-de-Cobre-Nu.8a228307.png";